import { m } from 'motion/react';
import {
  containerVariants,
  itemVariants,
  viewPort,
} from '../../../utils/framer';
import { LinkApp } from '../../components/rentAndShare/LinkApp';
import LinkButton from '../ui/LinkButton';

interface CardItem {
  image: string;
  title: string;
  description: string;
  alt: string;
  link?: string;
  linkText?: string;
  openInNewTab?: boolean;
  widthClass?: string;
  appLinks?: Array<{
    text: string;
    Icon: React.ElementType;
    href: string;
    target?: string;
  }>;
}

interface ImgAndTextCarCardProps {
  title: string;
  cards: CardItem[];
}

const ImgAndTextCarCard: React.FC<ImgAndTextCarCardProps> = ({
  title,
  cards,
}) => {
  return (
    <section className="px-6 mt-7 mb-20">
      <m.h2
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={itemVariants}
        className="text-center p-2 font-medium text-[32px] md:text-[40px] leading-[48px] mb-3 whitespace-pre-line break-normal"
      >
        {title}
      </m.h2>

      <m.div
        initial="hidden"
        whileInView="visible"
        viewport={viewPort}
        variants={containerVariants}
        className="grid grid-cols-1 md:grid-cols-3 gap-4 max-w-7xl mx-auto"
      >
        {cards.map((card, index) => (
          <m.div
            key={index}
            variants={itemVariants}
            className="flex flex-col text-left"
          >
            <div className="flex items-end w-full md:h-96">
              <m.img
                src={card.image}
                alt={card.alt}
                className={`object-cover w-full ${index === 1 ? 'md:h-96' : 'md:h-72'}`}
                variants={itemVariants}
              />
            </div>

            <m.h3
              variants={itemVariants}
              className="text-[20px] md:text-[24px] leading-[28px] mt-9 mb-3"
            >
              {card.title}
            </m.h3>

            <m.p variants={itemVariants} className="text-base leading-[24px]">
              {card.description}
            </m.p>

            {card.link && (
              <div className="flex justify-center md:justify-start">
                <LinkButton
                  url={card.link}
                  text={card.linkText || 'Läs mer'}
                  openInNewTab={card.openInNewTab}
                  className="mt-2"
                  widthClass={card.widthClass}
                />
              </div>
            )}

            {card.appLinks && (
              <div className="flex gap-4 mt-4">
                {card.appLinks.map((appLink, idx) => (
                  <LinkApp
                    key={idx}
                    text={appLink.text}
                    Icon={appLink.Icon}
                    href={appLink.href}
                    target={appLink.target || '_blank'}
                  />
                ))}
              </div>
            )}
          </m.div>
        ))}
      </m.div>
    </section>
  );
};

export default ImgAndTextCarCard;
